import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RootRoutes } from './root.routes';
import { RootComponent } from './root.component';

/**
 * Shared modules.
 */
import { PageHeaderModule } from '@app/shared/page-header/page-header.module';
import { PageFooterModule } from '@app/shared/page-footer/page-footer.module';
import { PageMobileMenuModule } from '@app/shared/page-mobile-menu/page-mobile-menu.module';
import { PageMobileProfileModule } from '@app/shared/page-mobile-profile/page-mobile-profile.module';
import { MainInstrumentsModule } from '@app/shared/main-instruments/main-instruments.module';
import { CrowdfundingModule } from '@app/shared/crowdfunding/crowdfunding.module';
import { MainBannersModule } from '@app/shared/main-banners/main-banners.module';
import { MainNewsModule } from '@app/shared/main-news/main-news.module';
import { CookiesContractModule } from '@app/shared/cookies-contract/cookies-contract.module';

@NgModule({
  declarations: [
    RootComponent
  ],
  exports: [
    RootComponent
  ],
  imports: [
    RouterModule.forChild(RootRoutes),
    CommonModule,
    MainInstrumentsModule,
    PageHeaderModule,
    PageFooterModule,
    PageMobileMenuModule,
    PageMobileProfileModule,
    CrowdfundingModule,
    MainBannersModule,
    MainNewsModule,
    CookiesContractModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class RootModule {}
